module.exports = __webpack_public_path__ + "img/boss.f129783c.jpg";